// extracted by mini-css-extract-plugin
export default {"dropdownOverlay":"TypeFilter_dropdownOverlay__neI--","clearMenuItem":"TypeFilter_clearMenuItem__AXXaz"};